import React from 'react';
import { Link } from 'react-router-dom';
import footerfacebook from '../assets/svg/footerfacebook.svg';
import footerinstagram from '../assets/svg/footerinstagram.svg';
import footerpinterest from '../assets/svg/footerpinterest.svg';
import footertwitter from '../assets/svg/footertwitter.svg';
import footeryoutube from '../assets/svg/footeryoutube.svg';

const Footer = () => {
  return (
    <>
      <footer className="bg-[#443F4B]">
        <div className="container mx-auto">
          <div className="px-2 py-6 flex flex-col items-center space-y-3 sm:space-y-0 sm:flex-row sm:justify-between">
            {/* Desktop: sve u jednom redu */}
            <div className="hidden sm:flex flex-wrap justify-start items-center gap-2 text-left">
              <span className="text-sm text-white">© Copyright 2026 - SphynxPlace.com</span>
              <span className="text-sm text-white">|</span>
              <Link to="/contact" className="text-sm text-white hover:text-gray-300">Contact</Link>
              <span className="text-sm text-white">|</span>
              <Link to="/privacy-policy" className="text-sm text-white hover:text-gray-300">Privacy Policy</Link>
              <span className="text-sm text-white">|</span>
              <Link to="/terms-and-conditions" className="text-sm text-white hover:text-gray-300">Terms & Conditions</Link>
              <span className="text-sm text-white">|</span>
              <a href="https://laracode.net" target="_blank" rel="noopener noreferrer" className="text-sm text-white hover:text-gray-300">
                Web Development by Laracode.net
              </a>
            </div>
            {/* Mobile: 4 reda */}
            <div className="flex flex-col items-center space-y-2 sm:hidden">
              <span className="text-sm text-white">© Copyright 2026 - SphynxPlace.com</span>
              <div className="flex items-center gap-2">
                <Link to="/contact" className="text-sm text-white hover:text-gray-300">Contact</Link>
                <span className="text-sm text-white">|</span>
                <Link to="/privacy-policy" className="text-sm text-white hover:text-gray-300">Privacy Policy</Link>
                <span className="text-sm text-white">|</span>
                <Link to="/terms-and-conditions" className="text-sm text-white hover:text-gray-300">Terms & Conditions</Link>
              </div>
              <a href="https://laracode.net" target="_blank" rel="noopener noreferrer" className="text-sm text-white hover:text-gray-300">
                Web Development by Laracode.net
              </a>
            </div>
            <div className="flex justify-center space-x-4 sm:space-x-6">
              <a href="https://www.facebook.com/groups/1133285998276992" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 p-2">
                <img src={footerfacebook} alt="footerfacebook" className="w-6 h-6" />
                <span className="sr-only">Facebook page</span>
              </a>
              {/* <a href="#" className="text-white hover:text-gray-300 p-2">
                <img src={footertwitter} alt="footertwitter" className="w-6 h-6" />
                <span className="sr-only">Twitter account</span>
              </a> */}
              <a href="https://www.instagram.com/sphynxplace/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 p-2">
                <img src={footerinstagram} alt="footerinstagram" className="w-6 h-6" />
                <span className="sr-only">Instagram page</span>
              </a>
              {/* <a href="#" className="text-white hover:text-gray-300 p-2">
                <img src={footeryoutube} alt="footeryoutube" className="w-6 h-6" />
                <span className="sr-only">Youtube account</span>
              </a> */}
              {/* <a href="#" className="text-white hover:text-gray-300 p-2">
                <img src={footerpinterest} alt="footerpinterest" className="w-6 h-6" />
                <span className="sr-only">Pinterest page</span>
              </a> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer